import { render } from "./ProcessMasterListB.vue?vue&type=template&id=37a45d8b"
import script from "./ProcessMasterListB.vue?vue&type=script&lang=js"
export * from "./ProcessMasterListB.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__